import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Modal from 'components/Modal'
import Input from 'components/Input'
import Button from 'components/Button'
import Divider from 'elements/Divider'
import Title from 'elements/Title'
import theme from '../../themes/light'

const Wrapper = styled.div`
  background: ${theme.colors.white};
  -webkit-app-region: drag;
  width: 100%;
  flex: 1 1 auto;
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: center;
`

const InputContainer = styled.div`
  padding-top: 2rem;
  padding-bottom: 2rem;
  padding-left: 5rem;
  padding-right: 5rem;
  width: 100%;
`

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 2rem;
`

class AddField extends Component {
  constructor (props) {
    super(props)
    this.state = {
      title: ''
    }
  }

  handleKeyDown = (e) => {
    // If 'enter' is pressed
    if (e.keyCode === 13 && this.state.title && this.state.title.length > 0) {
      e.preventDefault()
      e.stopPropagation()
      this.setState({
        title: ''
      })
      return this.props.onAddField(this.state.title)
    }
    return false
  }

  render () {
    const {
      isOpen,
      onModalClose,
      onAddField
    } = this.props
    const {
      title
    } = this.state

    return (
      <Modal
        isOpen={isOpen}
        onModalClose={() => {
          this.setState({
            title: ''
          })
          onModalClose()
        }}
      >
        <Wrapper
          onKeyDown={this.handleKeyDown}
        >
          <InputContainer>
            <Title align='center' mb='0.5rem'>Add Field</Title>
            <Input
              label='Field Name'
              inputId='title'
              value={title}
              onValueChange={(value) => {
                this.setState({
                  title: value
                })
              }}
              mt='1.5rem'
            />
          </InputContainer>
          <Divider />
          <ButtonContainer>
            <Button
              label='cancel'
              onClick={() => {
                this.setState({
                  title: ''
                })
                onModalClose()
              }}
              mr='0.5rem'
            />
            <Button
              primary
              disabled={!this.state.title || !(this.state.title.length > 0)}
              label='add field'
              onClick={() => {
                onAddField(this.state.title)
                this.setState({
                  title: ''
                })
              }}
            />
          </ButtonContainer>
        </Wrapper>
      </Modal>
    )
  }
}

AddField.propTypes = {
  isOpen: PropTypes.bool,
  onModalClose: PropTypes.func,
  onAddField: PropTypes.func
}

export default AddField
